import { AddNomineeDetails } from './AddNomineeDetails'

export default AddNomineeDetails
